import React, { useState, useEffect } from "react";
import { Handshake, Store, HeartHandshake, Mail, Music } from "lucide-react";
import { SponsorshipForm } from "./forms/SponsorshipForm";
import { VendorForm } from "./forms/VendorForm";
import { VolunteerForm } from "./forms/VolunteerForm";
import { StayUpdatedForm } from "./forms/StayUpdatedForm";
import { TalentForm } from "./forms/TalentForm";

const TABS = [
  { key: "sponsor", label: "Sponsorship", Icon: Handshake, Comp: SponsorshipForm },
  { key: "vendor", label: "Vendor Booth", Icon: Store, Comp: VendorForm },
  { key: "talent", label: "Talent", Icon: Music, Comp: TalentForm },
  { key: "volunteer", label: "Volunteer", Icon: HeartHandshake, Comp: VolunteerForm },
  { key: "updates", label: "Stay Updated", Icon: Mail, Comp: StayUpdatedForm },
];

const HASH_MAP = {
  "join-sponsor": "sponsor",
  "join-vendor": "vendor",
  "join-talent": "talent",
  "join-volunteer": "volunteer",
  "join-updates": "updates",
};

export const GetInvolved = () => {
  const [active, setActive] = useState("sponsor");
  const Active = TABS.find((t) => t.key === active).Comp;

  useEffect(() => {
    const apply = () => {
      const h = window.location.hash.replace("#", "");
      if (HASH_MAP[h]) {
        setActive(HASH_MAP[h]);
        document.getElementById("get-involved")?.scrollIntoView({ behavior: "smooth" });
      }
    };
    apply();
    window.addEventListener("hashchange", apply);
    return () => window.removeEventListener("hashchange", apply);
  }, []);

  return (
    <section id="get-involved" className="bg-cream-muted py-20 md:py-28 scroll-mt-20" data-testid="get-involved-section">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="eyebrow text-rust mb-3">Be Part Of Pak Fest</p>
          <h2 className="font-display font-extrabold text-forest text-4xl sm:text-5xl md:text-6xl tracking-tight mb-4">Get Involved</h2>
          <p className="tagline-italic text-forest-light text-2xl">Sponsor, sell, serve, or simply stay in the loop.</p>
        </div>

        {/* Tabs */}
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-3 mb-10">
          {TABS.map((t) => {
            const on = active === t.key;
            return (
              <button
                key={t.key}
                onClick={() => setActive(t.key)}
                className={`flex flex-col items-center gap-2 px-3 py-4 border-2 font-mono uppercase tracking-wide text-xs transition-all ${on ? "bg-forest text-cream border-forest shadow-blockgold" : "bg-cream text-forest border-forest/40 hover:border-forest"}`}
                data-testid={`tab-${t.key}`}
              >
                <t.Icon size={22} className={on ? "text-gold-light" : "text-rust"} />
                {t.label}
              </button>
            );
          })}
        </div>

        {/* Active form panel */}
        <div className="stamp p-3" data-testid="form-panel">
          <div className="stamp-inner p-6 md:p-10 bg-cream">
            <Active />
          </div>
        </div>
      </div>
    </section>
  );
};
